import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import { setupInterceptors } from './api/Interceptors';
import { getThemeAction } from './redux/actions/themeActions';

const AppContainer = () => {
    useEffect(() => {
        setupInterceptors(store);
        store.dispatch(getThemeAction());
    }, []);

    return (
        <Provider store={store}>
            <App />
        </Provider>
    );
};

export default AppContainer;
